import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormFeedback, FormGroup, Label, Row } from 'reactstrap';
import classnames from 'classnames';

import BrzwDatePicker from '../../../brzw_date_picker';

const FormControlDateRange = props => {
  const {
    classNameContainer,
    id,
    label,
    start_date: startDate,
    end_date: endDate,
    required,
  } = props;

  const validationState = {};
  const errorText = {};

  if (startDate.meta.touched) {
    if (startDate.meta.error) {
      validationState.startDate = 'danger';
      errorText.startDate = startDate.meta.error;
    } else {
      validationState.startDate = 'success';
    }
  }

  if (endDate.meta.touched) {
    if (endDate.meta.error) {
      validationState.endDate = 'danger';
      errorText.endDate = endDate.meta.error;
    } else {
      validationState.endDate = 'success';
    }
  }

  return (
    <FormGroup row className={classnames('form-group-row', classNameContainer)}>
      <Label for={id} className="form-group-row__label">
        {required ? (
          <span>
            {label} <span className="text-orange">*</span>
          </span>
        ) : (
          label
        )}
      </Label>
      <Col className="form-group-row__col">
        <Row>
          <Col xs={6}>
            <BrzwDatePicker
              className={classnames(
                'form-control form-group-row__input',
                validationState.startDate,
              )}
              endDate={endDate.input.value}
              isClearable={false}
              onChange={d => startDate.input.onChange(d)}
              selected={startDate.input.value}
              startDate={startDate.input.value}
            />
            <FormFeedback>{errorText.startDate}</FormFeedback>
          </Col>
          <Col xs={6}>
            <BrzwDatePicker
              className={classnames('form-control form-group-row__input', validationState.endDate)}
              endDate={endDate.input.value}
              isClearable={false}
              onChange={d => endDate.input.onChange(d)}
              selected={endDate.input.value}
              startDate={startDate.input.value}
            />
            <FormFeedback>{errorText.endDate}</FormFeedback>
          </Col>
        </Row>
      </Col>
    </FormGroup>
  );
};

FormControlDateRange.propTypes = {
  classNameContainer: PropTypes.string,
  end_date: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  start_date: PropTypes.shape({}),
  required: PropTypes.bool,
};

export default FormControlDateRange;
